import { useState, useEffect } from "react";
import useGetProductPrices from "../../../Components/BasketPage/Hooks/useGetProductPrices";
import { ConvertPriceToString } from "../../../Helpers/CustomConverter";
import ProductThreshold from "../../../Components/Components/ProductThreshold";
import ProductAvailabilityLevel from "../../../Components/Components/ProductAvailabilityLevel";
import ProductBuyBtn from "../../Shop/Components/ProductComponents/ProductBuyBtn";
import useHandleAddToBasketBtn from "../../Shop/Hooks/useHandleAddToBasketBtn";
import { useCart } from "../../../Providers/CartProvider";
import NewPromoSellOutTag from "../../../Components/Components/NewPromoSellOut/NewPromoSellOutTag";
import NewPromoSellOutOldPrice from "../../../Components/Components/NewPromoSellOut/NewPromoSellOutOldPrice";
import { useOffers } from "../../../Providers/OffersProvider";
import { useParams } from "../../../Providers/ParamsProvider";
import { useSavedBaskets } from "../../../Providers/SavedBasketsProvider";
import { useAuth } from "../../../Providers/AuthProvider";
import { FaShareAlt } from "react-icons/fa";
import useCommonFunctions from "../../Shop/Hooks/MobileAndDesktopCommon/useCommonFunctions";
import useGetProductIndexWithMask from "../../../Components/BasketPage/Hooks/useGetProductIndexWithMask";
import { OverlayTrigger, Popover } from "react-bootstrap";

const AddToBasketSection = ({ product }) => {
    const { wholesalePrices } = useAuth()
    const { GetProductQuantityInCart, cartItems } = useCart()
    const [quantityInCart, setQuantityInCart] = useState(0)
    const [quantity, setQuantity] = useState(product.salesRatio > 0 ? product.salesRatio : 1)
    const { handleBtnOnClick } = useHandleAddToBasketBtn(product, quantity);
    const { priceNet, priceGross } = useGetProductPrices(product, quantityInCart)
    const { savedOfferId, getProductQuantityInSavedOffer, selectedSavedOffer } = useOffers()
    const { isMobile } = useParams()
    const { selectedSavedBasket, getProductQuantityInSavedBasket } = useSavedBaskets()
    const { handleCopyToClipboard } = useCommonFunctions()
    const { getProductIndexWithMask } = useGetProductIndexWithMask()

    useEffect(() => {
        if (savedOfferId != -1) {
            setQuantityInCart(getProductQuantityInSavedOffer(product))
        }
        else if (selectedSavedBasket) {
            setQuantityInCart(getProductQuantityInSavedBasket(product))
        }
        else {
            setQuantityInCart(GetProductQuantityInCart(product))
        }
    }, [[], savedOfferId, selectedSavedBasket])

    useEffect(() => {
        let qtyToShow = quantityInCart > 0 ? quantityInCart : (product.salesRatio > 0 ? product.salesRatio : 1)
        setQuantity(qtyToShow)
    }, [quantityInCart])

    useEffect(() => {
        if (savedOfferId == -1) {
            setQuantityInCart(GetProductQuantityInCart(product))
        }
    }, [product, cartItems])

    useEffect(() => {
        if (savedOfferId != -1 && selectedSavedOffer && selectedSavedOffer.basketItems) {
            setQuantityInCart(getProductQuantityInSavedOffer(product))
        }
    }, [selectedSavedOffer])

    const OnChange = (e) => {
        let value = e.target.value
        setQuantity(value);
    }

    const shareProduct = async () => {
        const shareData = {
            title: `Produkt ${getProductIndexWithMask(product.index)}`,
            text: `Zobacz ten produkt: ${getProductIndexWithMask(product.index)}`,
            url: window.location.href
        }

        if (navigator.share) {
            try {
                await navigator.share(shareData)
            } catch (err) {
                console.error('Błąd udostępniania lub anulowano:', err)
            }
        } else {
            handleCopyToClipboard(window.location.href, `Skopiowano link do produktu ${getProductIndexWithMask(product.index)}`)
        }
    }

    const popover = () => <Popover id="popover-basic">
        <Popover.Body className="text-center">
            <span className='primary-accent-color-text'>{`Udostępnij produkt ${getProductIndexWithMask(product.index)}`}</span>
        </Popover.Body>
    </Popover>

    const fontSize = isMobile ? '12px' : '16px'
    const discountVisibility = !wholesalePrices || product.discount == 0 ? "hidden" : ""

    return (
        <div className="main-container-holder ps-5 pe-5">
            <div style={{ margin: '0 0 0 -16px' }}>
                <NewPromoSellOutTag
                    product={product}
                    isBigTag={true}
                    fontSize={fontSize}
                />
            </div>
            <div className="row">
                <div className="col">
                    <div className="d-flex align-items-center">
                        <span className="price-net">{ConvertPriceToString(priceNet, product.currency)}</span>
                        <NewPromoSellOutOldPrice product={product} />
                    </div>
                </div>
            </div>

            <div className="d-flex align-items-center">
                <span className="price-gross me-2">{ConvertPriceToString(priceGross, product.currency)}</span>
                <span className="light-text-color ms-2">{'brutto ' + product.taxRate} %</span>
            </div>
            <div className="row mt-4 mb-4">
                <div className="col">
                    <ProductBuyBtn
                        product={product}
                        quantityInCart={quantityInCart}
                        quantity={quantity}
                        setQuantity={setQuantity}
                        OnChange={OnChange}
                        onClick={handleBtnOnClick}
                        isBasketSummary={false}
                        isProductDetail={true}
                    />
                </div>
                <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover()}>
                    <div className="col-auto d-flex align-items-center">
                        <FaShareAlt size={20} color="var(--primary)" className="element-pointer" onClick={shareProduct} />
                    </div>
                </OverlayTrigger>
            </div>
            <div className="mt-3">
                <div className="row">
                    <div className="col-6">
                        <ProductThreshold
                            product={product}
                            isProductDetails={true}
                        />
                    </div>
                    <div className={`col-6 d-flex flex-column ${discountVisibility}`}>
                        <span className="secondary-text">Rabat</span>
                        <b style={{ fontSize: fontSize }}>{`${product.discount}%`}</b>
                    </div>
                </div>
            </div>
            <div className="mt-3">
                <ProductAvailabilityLevel
                    product={product}
                />
            </div>

        </div>
    )
}

export default AddToBasketSection